import { Component, computed, input, inject } from '@angular/core';
import { JssPlatformService } from '@core/jss-platform';
import { FieldService } from '@core/jss-utils';
import { JssModule, TextField } from '@sitecore-jss/sitecore-jss-angular';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { VideoPlayerComponent } from '@core/ui';

@Component({
  selector: 'wl-video',
  standalone: true,
  imports: [JssModule, VideoPlayerComponent],
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.ed.scss', './video.component.essent.scss'],
})
export class VideoComponent {
  readonly #jssPlatformService = inject(JssPlatformService);
  readonly #fieldService = inject(FieldService);
  readonly #environmentConfig = inject(ENVIRONMENT_CONFIG);

  readonly headingField = input.required<TextField>();
  readonly videoIdField = input.required<TextField>();
  readonly descriptionField = input<TextField>();

  readonly isEd = computed(() => this.#environmentConfig.brand === 'ed');

  readonly showDescriptionField = computed(() =>
    this.#fieldService.showTextField(this.descriptionField())
  );

  readonly isEditorActive = computed(() =>
    this.#jssPlatformService.isEditorActive()
  );
}
